var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6932 21.5L15.6932 15.5M3.69324 10.5C3.69324 11.4193 3.8743 12.3295 4.22608 13.1788C4.57786 14.0281 5.09348 14.7997 5.74349 15.4497C6.3935 16.0998 7.16517 16.6154 8.01445 16.9672C8.86373 17.3189 9.77398 17.5 10.6932 17.5C11.6125 17.5 12.5227 17.3189 13.372 16.9672C14.2213 16.6154 14.993 16.0998 15.643 15.4497C16.293 14.7997 16.8086 14.0281 17.1604 13.1788C17.5122 12.3295 17.6932 11.4193 17.6932 10.5C17.6932 9.58075 17.5122 8.6705 17.1604 7.82122C16.8086 6.97194 16.293 6.20026 15.643 5.55025C14.993 4.90024 14.2213 4.38463 13.372 4.03284C12.5227 3.68106 11.6125 3.5 10.6932 3.5C9.77398 3.5 8.86373 3.68106 8.01445 4.03284C7.16517 4.38463 6.3935 4.90024 5.74349 5.55025C5.09348 6.20026 4.57786 6.97194 4.22608 7.82122C3.8743 8.6705 3.69324 9.58075 3.69324 10.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerSearch);
export default __webpack_public_path__ + "static/media/tabler_search.1a1f8ebc14ec00992ff52c31eca1fbda.svg";
export { ForwardRef as ReactComponent };